import { section } from '@/neon';

const sel = {
  toggle: '[data-js-toggle]',
};

section('password', {
  onLoad() {
    this.toggleButton = this.container.querySelector(sel.toggle);
    this.toggleButton.addEventListener('click', e => this.toggleView(e));

    const passwordInput = this.container.querySelector('[data-storefront-password-input]');

    if (passwordInput) {
      if (passwordInput.className.indexOf('storefront-password-error') >= 0) {
        this.toggleView();
      }
    }
  },

  onUnload() {
    this.toggleButton.removeEventListener('click', e => this.toggleView(e));
  },

  toggleView(e) {
    e && e.preventDefault();
    this.container.classList.toggle('welcome');
  },
});
